import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NodeType } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/node-type';
import { NodoArbolMenu } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/nodo-arbol-menu';
import { EditingMode } from '../../models/editingMode';
import { ConfigService } from '../config.service';

@Component({
  selector: 'app-config-node',
  templateUrl: './config-node.component.html',
  styleUrls: ['./config-node.component.scss']
})
export class ConfigNodeComponent implements OnInit, OnChanges {
  @Output() nodeEmitter: EventEmitter<string>;
  @Output() renderMenuArbolEmitter: EventEmitter<string>;
  @Output() displayAnswerEmitter: EventEmitter<NodoArbolMenu>;
  @Input("node") node: NodoArbolMenu;
  @Input("habilitado") habilitado: boolean;
  @Input("cantidadNodos") cantidadNodos: number;
  @Input("numberOfSiblingsArr") numberOfSiblingsArr: number[];
  @Input("numberOfSiblingsArrCreation") numberOfSiblingsArrCreation: number[];
  displayAnswer: boolean; //mostrar la respuesta si el nodo es de tipo respuesta y el usuario clickea en el nodo
  @Input() faqsGlobal: any[] = [];


  @Output() editingModeEmitter: EventEmitter<EditingMode>;

  constructor(private configService: ConfigService) {
    this.displayAnswer = false;
    this.nodeEmitter = new EventEmitter<string>();
    this.displayAnswerEmitter = new EventEmitter<NodoArbolMenu>()
    this.renderMenuArbolEmitter = new EventEmitter<string>();
    this.editingModeEmitter = new EventEmitter<EditingMode>();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['faqsGlobal']) {
    console.log("faqsGlobal llegó al hijo:", this.faqsGlobal);
  }
}


  // selectNode(){
  //   switch(this.node.type){
  //     case NodeType.Question:{
  //       this.nodeEmitter.emit(this.node.id.toString());
  //       break;
  //     }
  //     case NodeType.Response:{
  //       this.displayAnswer = !this.displayAnswer;
  //       break;   
  //     }
  //     case NodeType.FAQ:{
  //       this.displayAnswer = !this.displayAnswer;
  //       break;   
  //     }
  //   }
  // }
  selectNode() {
    switch (this.node.type) {
      case NodeType.Action: {
        //this.renderMenuArbolEmitter.emit(this.node.assistanceId)
        break;
      }
      case NodeType.Question: {
        this.nodeEmitter.emit(this.node.id.toString());
        break;
      }
      case NodeType.Tramite: {
        this.nodeEmitter.emit(this.node.id.toString());
        break;
      }
      case NodeType.Response: {
        this.displayAnswerEmitter.emit(this.node)
        break;
      }
      case NodeType.FAQ: {
        this.displayAnswerEmitter.emit(this.node)
        break;
      }
    }
  }

  public get NodeType() {
    return NodeType;
  }

  deleteNode() {
    this.editingModeEmitter.emit(EditingMode.Delete);
    this.configService.updateEditingData({ node: this.node, mode: EditingMode.Delete, cantidadNodos: this.cantidadNodos, numberOfSiblingsArr: this.numberOfSiblingsArr, numberOfSiblingsArrCreation: this.numberOfSiblingsArrCreation, faqsGlobal: this.faqsGlobal });
  }

  editNode() {
    //debugger
    this.editingModeEmitter.emit(EditingMode.Update);
    this.configService.updateEditingData({ node: this.node, mode: EditingMode.Update, cantidadNodos: this.cantidadNodos, numberOfSiblingsArr: this.numberOfSiblingsArr, numberOfSiblingsArrCreation: this.numberOfSiblingsArrCreation, faqsGlobal: this.faqsGlobal });
  }

  addChildNode() {
    this.editingModeEmitter.emit(EditingMode.Create);
    let path = this.node.id === "ROOT" ? "Inicio" : `${this.node.path} `;
    let node = new NodoArbolMenu("-1", this.node.idAsistente, "Seleccione un nombre", undefined, NodeType.Question, this.node.id, undefined, undefined, undefined, undefined, path, "1")
    node.idAsistente = this.node.idAsistente;
    this.configService.updateEditingData({ node: node, mode: EditingMode.Create, cantidadNodos: this.cantidadNodos, numberOfSiblingsArr: this.numberOfSiblingsArr, numberOfSiblingsArrCreation: this.numberOfSiblingsArrCreation, faqsGlobal: this.faqsGlobal })
  }
}
